import { render, staticRenderFns } from "./CustomAttributesForm.vue?vue&type=template&id=585b8614&"
import script from "./CustomAttributesForm.vue?vue&type=script&lang=js&"
export * from "./CustomAttributesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports